export default "__VITE_ASSET__65bd1c52__"